module.exports = __webpack_public_path__ + "img/logo.4bc1761.svg";